import { render, staticRenderFns } from "./OrderSheetViewTabPay.vue?vue&type=template&id=37ad9a2f&"
import script from "./OrderSheetViewTabPay.vue?vue&type=script&lang=js&"
export * from "./OrderSheetViewTabPay.vue?vue&type=script&lang=js&"
import style0 from "./OrderSheetViewTabPay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports